import { createRouter, createWebHistory } from "vue-router";
import { $tf } from "@/plugins/i18n";
const Other = () => import("@/views/Other.vue");
const EmployeeTime = () => import("@/views/census/user/EmployeeTime");
const Employees = () => import("@/views/census/user/EmployeeList");
const UserList = () => import("@/views/user-management/UserList.vue");
const UserInvitation = () =>
  import("@/views/user-management/UserInvitation.vue");
const EnterpriseProjectList = () =>
  import("@/views/enterprise/project/ProjectList");
const EnterpriseClientList = () => import("@/views/enterprise/client/Clients");
const EnterpriseProjectCreate = () =>
  import("@/views/enterprise/project/ProjectCreate");
const EnterpriseProjectDetails = () =>
  import("@/views/enterprise/project/ProjectDetails");
const EnterpriseOutsourceProjectDetails = () =>
  import("@/views/enterprise/project/OutsourceProjectDetails");
const EnterpriseSupportProjectDetails = () =>
  import("@/views/enterprise/project/SupportProjectDetails");
const EnterpriseMoneylessProjectDetails = () =>
  import("@/views/enterprise/project/MoneylessProjectDetails");
const EnterpriseTiers = () => import("@/views/enterprise/tiers/Tiers");
const EnterpriseOverview = () => import("@/views/enterprise/admin/Overview");
const InvoiceList = () => import("@/views/enterprise/invoices/InvoiceList.vue");
const TenantList = () => import("@/views/tenant/TenantList");
const AbsenceRequestsAdmin = () =>
  import("@/views/absence/request/AllAbsenceRequests");
const AbsenceReports = () => import("@/views/absence/Reports");
const AbsenceSpecialDay = () => import("@/views/absence/SpecialDay");
const AdminRequest = () => import("@/views/absence/request/AdminRequest");
const WorkScheduleList = () =>
  import("@/views/census/workschedule/WorkScheduleList");
const WorkScheduleForm = () =>
  import("@/views/census/workschedule/WorkScheduleForm");
const AbsenceHandleAbsenceRequestList = () =>
  import("@/views/absence/request/HandleAbsenceRequestList");
const AbsenceHandleAbsenceRequestForm = () =>
  import("@/views/absence/request/HandleAbsenceRequestForm");
const QuotaList = () => import("@/views/absence/quota/QuotaList");
const QuotaForm = () => import("@/views/absence/quota/QuotaForm");
const MyWorkScheduleForm = () =>
  import("@/views/census/workschedule/MyWorkScheduleForm");
const ProjectDimensions = () =>
  import("@/views/enterprise/project/dimension/ProjectDimensions.vue");
const ProjectDimensionAssigner = () =>
  import("@/views/enterprise/project/dimension/ProjectDimensionAssigner.vue");
const ProjectBaseData = () =>
  import("@/views/enterprise/project/ProjectBaseData.vue");
const OvertimePolicies = () =>
  import("@/views/enterprise/overtime/policy/OvertimePolicies");
const HandleOvertimeRequestList = () =>
  import("@/views/enterprise/overtime/request/HandleOvertimeRequestList");
const HandleOvertimeRequestForm = () =>
  import("@/views/enterprise/overtime/request/HandleOvertimeRequestForm");
const PendingRequestsPage = () => import("@/views/request/PendingRequestsPage");
const Teams = () => import("@/views/census/team/TeamList");
const TeamEdit = () => import("@/views/census/team/TeamEdit");
const RiskManagement = () => import("@/views/enterprise/admin/RiskManagement");
const Statistics = () => import("@/views/enterprise/admin/Statistics");
const UserIndicatorList = () =>
  import("@/views/census/indicator/UserIndicatorList");
const WorkScheduleSiteList = () =>
  import("@/views/census/workschedule/WorkScheduleSiteList");
const AbsenceTypeList = () => import("@/views/absence/type/AbsenceTypeList");
const Profile = () => import("@/views/user-management/Profile");
const SignIn = () => import("@/views/SignIn");
const UserRegistration = () => import("@/views/UserRegistration.vue");
const RootSignIn = () => import("@/views/RootSignIn.vue");
const ForgotPassword = () => import("@/views/ForgotPassword.vue");
import store from "../store";
const Sites = () => import("@/views/census/seating/SiteList");
const SiteEdit = () => import("@/views/census/seating/SiteEdit");
const RoomEdit = () => import("@/views/census/seating/RoomEdit");
const SeatEdit = () => import("@/views/census/seating/SeatEdit");
const MySeatingArrangement = () =>
  import("@/views/census/seating/MySeatingArrangement");
const SeatingCanvasDrawing = () =>
  import("@/views/census/seating/SeatingArrangementCanvasDrawing");
const SeatingCanvasReadOnly = () =>
  import("@/views/census/seating/SeatingArrangementCanvasReadOnly");
const Permissions = () =>
  import("@/views/census/permission/UserPermissionList");
const HandePermissionRequestList = () =>
  import("@/views/census/permission/HandlePermissionRequestList");
const ResetPassword = () => import("@/views/ResetPassword");
const ActiveLoginsList = () => import("@/views/session/ActiveLoginsList");
const AdminConfigEdit = () =>
  import("@/views/admin-config/AdminConfigEdit.vue");
const ExecutiveDashboard = () =>
  import("@/views/enterprise/admin/ExecutiveDashboard.vue");
const UploadAssociations = () =>
  import("@/views/ralloc/UploadAssociations.vue");
const LoggingView = () => import("@/views/enterprise/logging/LoggingView.vue");
const SelfTrackingTaskList = () =>
  import("@/views/enterprise/logging/SelfTrackingTaskList.vue");
const ProjectAggregationView = () =>
  import("@/views/enterprise/project/aggregation/ProjectAggregationView.vue");
const ProjectAggregationListView = () =>
  import(
    "@/views/enterprise/project/aggregation/ProjectAggregationListView.vue"
  );
const SettingsView = () => import("@/views/settings/SettingsView.vue");

const ForecastSegment = () =>
  import("@/views/enterprise/forecast/ForecastSegment");
const ForecastChanceCategory = () =>
  import("@/views/enterprise/forecast/ForecastChanceCategory.vue");
const ForecastScenario = () =>
  import("@/views/enterprise/forecast/ForecastScenario.vue");
const ForecastPlan = () => import("@/views/enterprise/forecast/ForecastPlan");
const ForecastFact = () => import("@/views/enterprise/forecast/ForecastFact");
import { PRIVILEGES } from "@/utils/const";
import TimeManagementOverview from "@/views/time-management/TimeManagementOverview.vue";
const RoleEditor = () => import("@/views/admin-config/RoleEditor.vue");

const OnboardingPage = () => import("@/views/OnboardingPage.vue");
const ForecastDashboard = () =>
  import("@/views/enterprise/forecast/ForecastDashboard.vue");
const RallocMainPage = () => import("@/views/ralloc/RallocMainPage.vue");
const ProjectResourceView = () =>
  import("@/views/ralloc/ProjectResourceView.vue");
const TimeManagementLoggingView = () =>
  import("@/views/time-management/TimeManagementLoggingView.vue");

const RiportListPage = () => import("@/views/riporting/RiportListPage.vue");
const RiportDisplayPage = () =>
  import("@/views/riporting/RiportDisplayPage.vue");

const MyAbsenceRequestsPage = () =>
  import("@/views/absence/MyAbsenceRequestsPage.vue");
const AbsenceRequestPage = () =>
  import("@/views/absence/AbsenceRequestPage.vue");
const OvertimeRequestPage = () =>
  import("@/views/enterprise/overtime/request/OvertimeRequestPage.vue");

const FinancialDashboard = () =>
  import("@/views/dashboard/FinancialDashboard.vue");

const EmployeeExplorer = () => import("@/views/employee/EmployeeExplorer.vue");

import {
  TIME_MANAGEMENT_LOGGING_TABS,
  OVERVIEW_TABS,
  PENDING_REQUESTS_TABS,
  RALLOC_TABS_ENUM,
  PROJECT_TABS,
} from "@/utils/const";

const routes = [
  // New Refined Pages
  {
    path: "/time-management/logging",
    name: "TimeManagementLogging",
    component: TimeManagementLoggingView,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case TIME_MANAGEMENT_LOGGING_TABS.DAILY:
            secondBreadcrumb = {
              label: "timeManagement.daily|Napi",
            };
            break;
          case TIME_MANAGEMENT_LOGGING_TABS.TIMESHEET:
            secondBreadcrumb = {
              label: "timeManagement.timesheet|Timesheet",
            };
            break;
          case TIME_MANAGEMENT_LOGGING_TABS.IMPORT:
            secondBreadcrumb = {
              label: "timeManagement.import|Import",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.daily|Napi",
            };
            break;
        }
        return [
          { label: "sidebar.time|Időkezelés" },
          { label: "sidebar.time.timeLogging|Időkövetés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/reporting/my-reports",
    name: "ReportingMyReports",
    component: RiportListPage,
    props: {
      factory: false,
    },
    meta: {
      breadcrumb: [
        { label: "sidebar.reporting.menu|Jelentések" },
        { label: "reporting.breadcrumbs.mine|Riportjaim" },
      ],
    },
  },
  {
    path: "/reporting/reports",
    name: "ReportingFactoryReports",
    component: RiportListPage,
    props: {
      factory: true,
    },
    meta: {
      breadcrumb: [
        { label: "sidebar.reporting.menu|Jelentések" },
        { label: "reporting.breadcrumbs.factory|Riportjaim" },
      ],
    },
  },
  {
    path: "/reporting/report/:id?",
    name: "RiportDisplayPage",
    component: RiportDisplayPage,
    meta: {
      sidebarItemKey: "controlling.aggregation",
      breadcrumb: (route) => [
        { label: "sidebar.reporting.menu|Jelentések" },
        {
          label: "reporting.breadcrumbs.factory|Riportok",
          to: "/reporting/reports",
        },
        {
          label: route.params?.id
            ? `reportDisplay.view_aggregation|View Report`
            : "reportDisplay.new_aggregation|New Report",
        },
      ],
    },
  },
  // Old Main views
  {
    path: "/",
    name: "Home",
    component: store.getters["session/isRoot"]
      ? TenantList
      : TimeManagementOverview,
    meta: {
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case OVERVIEW_TABS.LOGGED_TIME.value:
            secondBreadcrumb = {
              label: "timeManagement.loggedTime|Logolások",
            };
            break;
          case OVERVIEW_TABS.TIME_OFF.value:
            secondBreadcrumb = {
              label: "timeManagement.timeOff|Szabadságok",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.loggedTime|Logolások",
            };
            break;
        }
        return [
          { label: "sidebar.time|Időkezelés" },
          { label: "sidebar.time.overview|Áttekintés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/logging",
    name: "Logging",
    component: LoggingView,
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: SelfTrackingTaskList,
  },
  {
    path: "/my-schedule/edit/:year?",
    name: "AbsenceMyWorkScheduleForm",
    component: MyWorkScheduleForm,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.WORKSCHEDULE.GET,
        PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN,
      ],
    },
  },
  {
    path: "/my-seating",
    name: "MySeatingArrangement",
    component: MySeatingArrangement,
  },
  {
    path: "/colleagues",
    name: "Colleagues",
    component: Employees,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.MISC.LIST_COLLEAGUES,
        PRIVILEGES.CENSUS.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/statistics",
    name: "ControllingStatistics",
    component: Statistics,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.MISC.LIST_STATISTICS,
        PRIVILEGES.ENTERPRISE.MISC.ADMIN,
      ],
    },
  },
  // Absence pages
  {
    path: "/my-absence-requests",
    name: "MyAbsenceRequests",
    component: MyAbsenceRequestsPage,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.GET,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        { label: "myAbsenceRequestsPage.title|Szabadságkérelem" },
      ],
    },
  },
  {
    path: "/absence-request/:id",
    name: "AbsenceRequest",
    component: AbsenceRequestPage,
    props: true,

    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.GET,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
      sidebarItemKey: "requests",

      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        {
          label: "pendingRequestsPage.title|Kérelmek",
          to: "/pending-requests",
        },
        { label: "absenceRequestPage.title|Távollátkérelem áttekintése" },
      ],
    },
  },
  // AbsenceAdmin pages
  {
    path: "/absence/admin/requests",
    name: "AbsenceAdminRequests",
    component: AbsenceRequestsAdmin,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.CREATE_ANY,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/create",
    name: "AbsenceAdminCreate",
    component: AdminRequest,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.CREATE_ANY,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/special-days",
    name: "AbsenceAdminSpecialDays",
    component: AbsenceSpecialDay,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.SPECIAL_DAY.CREATE,
        PRIVILEGES.ABSENCE.SPECIAL_DAY.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/quotas",
    name: "AbsenceQuotas",
    component: QuotaList,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.QUOTA.LIST,
        PRIVILEGES.ABSENCE.QUOTA.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/quota/:year",
    name: "AbsenceQuota",
    component: QuotaForm,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.QUOTA.CREATE,
        PRIVILEGES.ABSENCE.QUOTA.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/absence/admin/reports",
    name: "AbsenceReports",
    component: AbsenceReports,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.MISC.EXPORT_ABSENCES,
        PRIVILEGES.ABSENCE.MISC.ADMIN,
      ],
    },
  },
  // Controlling pages
  {
    path: "/controlling/dashboard",
    name: "ControllingDashboard",
    component: ExecutiveDashboard,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.MISC.LIST_OVERVIEW,
        PRIVILEGES.ENTERPRISE.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/controlling/timesheet",
    name: "ControllingTimesheet",
    component: EmployeeTime,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ASSIGNED,
        PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY,
        PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN,
      ],
      breadcrumb: [
        { label: "sidebar.controlling.menu|Felügyelet" },
        { label: "sidebar.controlling.timesheets|Timesheetek" },
      ],
    },
  },
  {
    path: "/controlling/project-aggregation/:id?",
    name: "ProjectAggregation",
    component: ProjectAggregationView,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ANY,
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.ADMIN,
      ],
    },
  },
  {
    path: "/controlling/aggregation-list",
    name: "AggregationSettings",
    component: ProjectAggregationListView,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ANY,
        PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.ADMIN,
      ],
    },
  },
  {
    path: "/projects/list",
    name: "ControllingProjects",
    component: EnterpriseProjectList,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.hash) {
          case PROJECT_TABS.HASH.ALL:
            secondBreadcrumb = {
              label: "sidebar.projects.all|Összevont",
            };
            break;
          case PROJECT_TABS.HASH.SIMPLE:
            secondBreadcrumb = {
              label: "sidebar.projects.normal|Hagyományos",
            };
            break;
          case PROJECT_TABS.HASH.SUPPORT:
            secondBreadcrumb = {
              label: "sidebar.projects.support|Folyamatos",
            };
            break;
          case PROJECT_TABS.HASH.OUTSOURCE:
            secondBreadcrumb = {
              label: "sidebar.projects.outsource|Outsource",
            };
            break;
          case PROJECT_TABS.HASH.MONEYLESS:
            secondBreadcrumb = {
              label: "sidebar.projects.moneyless|Publikus",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "sidebar.projects.all|Összevont",
            };
            break;
        }
        return [{ label: "sidebar.projects.menu|Projektek" }, secondBreadcrumb];
      },
    },
  },
  {
    path: "/projects/project-create",
    name: "ControllingProjectCreate",
    component: EnterpriseProjectCreate,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.CREATE,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
    },
  },
  {
    path: "/projects/project/:id",
    name: "NormalProjectDetails",
    component: EnterpriseProjectDetails,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.GET_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      sidebarItemKey: "projects.simple",
    },
  },
  {
    path: "/projects/outsource/:id",
    name: "OutsourceProjectDetails",
    component: EnterpriseOutsourceProjectDetails,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.GET_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      sidebarItemKey: "projects.outsource",
    },
  },
  {
    path: "/projects/support/:id",
    name: "SupportProjectDetails",
    component: EnterpriseSupportProjectDetails,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.GET_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      sidebarItemKey: "projects.support",
    },
  },
  {
    path: "/projects/public/:id",
    name: "MoneylessProjectDetails",
    component: EnterpriseMoneylessProjectDetails,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.GET_PUBLIC,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      sidebarItemKey: "projects.public",
    },
  },
  {
    path: "/controlling/query",
    name: "ControllingQuery",
    component: EnterpriseOverview,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED,
        PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY,
        PRIVILEGES.ENTERPRISE.PROJECT.ADMIN,
      ],
      breadcrumb: [
        { label: "sidebar.controlling.menu|Felügyelet" },
        { label: "sidebar.controlling.timesheet_query|Lekérdezés" },
      ],
    },
    props: {
      showMoney: true,
    },
  },
  {
    path: "/controlling/risk-management",
    name: "ControllingRiskManagement",
    component: RiskManagement,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ASSIGNED,
        PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ANY,
        PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.ADMIN,
      ],
      breadcrumb: [
        { label: "sidebar.controlling.menu|Felügyelet" },
        { label: "sidebar.controlling.risk_management|Kockázatmenedzsment" },
      ],
    },
  },
  {
    path: "/controlling/seating",
    name: "ControllingSeating",
    component: SeatingCanvasDrawing,
  },
  {
    path: "/controlling/seating-availability",
    name: "CanvasReadonly",
    component: SeatingCanvasReadOnly,
  },
  {
    path: "/approval/permissions",
    name: "UserPermissionList",
    component: HandePermissionRequestList,
  },
  {
    path: "/controlling/logins",
    name: "ActiveLoginsList",
    component: ActiveLoginsList,
    meta: {
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/controlling/invoices",
    name: "InvoiceList",
    component: InvoiceList,
    meta: {
      authorities: [PRIVILEGES.ENTERPRISE.PROJECT_EXTRAS.ADMIN],
      breadcrumb: [
        { label: "Projects", to: "/projects/list" },
        { label: "invoiceList.title|Számlák" },
      ],
    },
  },
  {
    path: "/controlling/upload-associations",
    name: "UploadAssociations",
    component: UploadAssociations,
    meta: {
      authorities: [
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE,
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN,
      ],
    },
  },
  {
    path: "/ralloc/utilization",
    name: "RallocMainPage",
    component: RallocMainPage,
    meta: {
      authorities: [
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE,
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN,
      ],
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case RALLOC_TABS_ENUM.EMPLOYEES.value:
            secondBreadcrumb = {
              label: "timeManagement.employees|Alkalmazottak",
            };
            break;
          case RALLOC_TABS_ENUM.PROJECTS.value:
            secondBreadcrumb = {
              label: "timeManagement.projects|Projektek",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "timeManagement.projects|Projektek",
            };
            break;
        }
        return [
          { label: "sidebar.resource|Erőforrások" },
          { label: "sidebar.resource.ralloc.utilization|Erőforrás-tervezés" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/employee-explorer",
    name: "EmployeeExplorer",
    component: EmployeeExplorer,
    meta: {
      authorities: [
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE,
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN,
      ],
      breadcrumb: [
        { label: "sidebar.resource|Erőforrások" },
        { label: "sidebar.resource.employeeExplorer|Felhasználó-böngésző" },
      ],
    },
  },
  {
    path: "/ralloc/project/:id",
    name: "ProjectResourceView",
    component: ProjectResourceView,
    meta: {
      authorities: [
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE,
        PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN,
      ],
    },
  },

  // Reporting pages
  {
    path: "/reports/timesheet",
    name: "ReportingTimesheet",
    component: EmployeeTime,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY,
        PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN,
      ],
    },
  },
  {
    path: "/reports/query",
    name: "ReportingMoneylessReport",
    component: EnterpriseOverview,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.REPORT.GET_MONEYLESS,
        PRIVILEGES.ENTERPRISE.REPORT.ADMIN,
      ],
    },
  },

  // Settings pages
  {
    path: "/settings",
    name: "Settings",
    component: SettingsView,
    meta: {
      breadcrumb: [{ label: "Settings" }],
    },
  },
  {
    path: "/settings/teams",
    name: "Teams",
    component: Teams,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.TEAM.CREATE,
        PRIVILEGES.CENSUS.TEAM.ADMIN,
      ],
      breadcrumb: [{ label: "Settings", to: "/settings" }, { label: "Teams" }],
    },
  },
  {
    path: "/settings/team/:id?",
    name: "TeamEdit",
    component: TeamEdit,
    props: true,
    meta: {
      authorities: [PRIVILEGES.CENSUS.TEAM.EDIT, PRIVILEGES.CENSUS.TEAM.ADMIN],
      breadcrumb: [
        { label: "Settings", to: "/settings" },
        { label: "Teams", to: "/settings/teams" },
        { label: "Team edit" },
      ],
    },
  },
  {
    path: "/settings/tiers",
    name: "SettingsTiers",
    component: EnterpriseTiers,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.TIER.LIST_ANY,
        PRIVILEGES.ENTERPRISE.TIER.ADMIN,
      ],
    },
  },
  {
    path: "/settings/project-dimensions",
    name: "SettingsProjectDimensions",
    component: ProjectDimensions,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.CREATE,
        PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.ADMIN,
      ],
    },
  },
  {
    path: "/settings/project-dimensions/assign",
    name: "SettingsProjectDimensionsAssign",
    component: ProjectDimensionAssigner,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.CREATE,
        PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.ADMIN,
      ],
    },
  },
  {
    path: "/settings/project-base-data",
    name: "SettingsProjectBaseData",
    component: ProjectBaseData,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.PROJECT_BASE_DATA.LIST,
        PRIVILEGES.ENTERPRISE.PROJECT_BASE_DATA.ADMIN,
      ],
    },
  },
  {
    path: "/settings/clients",
    name: "SettingsClients",
    component: EnterpriseClientList,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.CLIENT.CREATE,
        PRIVILEGES.ENTERPRISE.CLIENT.ADMIN,
      ],
    },
  },
  {
    path: "/settings/overtime-policies",
    name: "SettingsOvertimePolicies",
    component: OvertimePolicies,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.OVERTIME.LIST_POLICY,
        PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN,
      ],
    },
  },
  {
    path: "/settings/seating",
    name: "SettingsSites",
    component: Sites,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.MISC.CREATE_SITE,
        PRIVILEGES.CENSUS.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/census/seating/site/:id?",
    name: "SiteEdit",
    component: SiteEdit,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.MISC.EDIT_SITE,
        PRIVILEGES.CENSUS.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/census/seating/room/:id?",
    name: "RoomEdit",
    component: RoomEdit,
    props: true,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.MISC.EDIT_SITE,
        PRIVILEGES.CENSUS.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/census/seating/seat/:id?",
    name: "SeatEdit",
    component: SeatEdit,
    props: true,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.MISC.EDIT_SITE,
        PRIVILEGES.CENSUS.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/settings/permissions",
    name: "Permissions",
    component: Permissions,
  },
  {
    path: "/settings/tenants",
    name: "TenantList",
    component: TenantList,
  },
  {
    path: "/settings/admin-config",
    name: "AdminConfig",
    component: AdminConfigEdit,
    meta: {
      authorities: [PRIVILEGES.TENANT.CONFIG.ADMIN],
    },
  },
  {
    path: "/settings/roles",
    name: "RoleEditor",
    component: RoleEditor,
    meta: {
      authorities: [
        PRIVILEGES.BULWARK.ROLE.LIST,
        PRIVILEGES.BULWARK.ROLE.ADMIN,
      ],
    },
  },
  // Requests pages
  {
    path: "/pending-requests",
    name: "PendingRequestsPage",
    component: PendingRequestsPage,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST,
        PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN,
        PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED,
        PRIVILEGES.ABSENCE.REQUEST.LIST_ANY,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
      breadcrumb: (route) => {
        let secondBreadcrumb;
        switch (route.query?.tab) {
          case PENDING_REQUESTS_TABS.TIME_OFF:
            secondBreadcrumb = {
              label: "pendingRequestsPage.tab.absence|Szabadság",
            };
            break;
          case PENDING_REQUESTS_TABS.OVERTIME:
            secondBreadcrumb = {
              label: "pendingRequestsPage.tab.overtime|Túlóra",
            };
            break;
          default:
            secondBreadcrumb = {
              label: "pendingRequestsPage.tab.absence|Szabadság",
            };
            break;
        }
        return [
          { label: "sidebar.time|Időkezelés" },
          { label: "pendingRequestsPage.title|Kérelmek" },
          secondBreadcrumb,
        ];
      },
    },
  },
  {
    path: "/approval/overtime",
    name: "HandleOvertimeRequestList",
    component: HandleOvertimeRequestList,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST,
        PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN,
      ],
    },
  },
  {
    path: "/approval/overtime/handle-requests/:id",
    name: "HandleOvertimeRequestForm",
    component: HandleOvertimeRequestForm,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST,
        PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN,
      ],
      sidebarItemKey: "requests",
    },
  },
  {
    path: "/overtime-request/:id",
    name: "OvertimeRequest",
    component: OvertimeRequestPage,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST,
        PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN,
      ],
      sidebarItemKey: "requests",
      breadcrumb: [
        { label: "sidebar.time|Időkezelés" },
        {
          label: "pendingRequestsPage.title|Kérelmek",
          to: "/pending-requests",
        },
        { label: "overtimeRequestPage.title|Túlórakérelem áttekintése" },
      ],
    },
    props: true,
  },
  {
    path: "/approval/absence",
    name: "AbsenceHandleAbsenceRequestList",
    component: AbsenceHandleAbsenceRequestList,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED,
        PRIVILEGES.ABSENCE.REQUEST.LIST_ANY,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
    },
  },
  {
    path: "/approval/absence/handle-requests/:id",
    name: "AbsenceHandleAbsenceRequestForm",
    component: AbsenceHandleAbsenceRequestForm,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.REQUEST.APPROVE_ASSIGNED,
        PRIVILEGES.ABSENCE.REQUEST.APPROVE_ANY,
        PRIVILEGES.ABSENCE.REQUEST.ADMIN,
      ],
    },
  },
  // UserAdmin pages
  {
    path: "/census/management",
    name: "PeopleManagement",
    component: UserList,
    meta: {
      authorities: [PRIVILEGES.CENSUS.USER.GET, PRIVILEGES.CENSUS.USER.ADMIN],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/census/management/invite",
    name: "UserInvitation",
    component: UserInvitation,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.USER.CREATE,
        PRIVILEGES.CENSUS.USER.EDIT,
        PRIVILEGES.CENSUS.USER.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/census/attributes",
    name: "UserIndicatorList",
    component: UserIndicatorList,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.INDICATOR.CREATE,
        PRIVILEGES.CENSUS.INDICATOR.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/settings/work-schedule/sites",
    name: "WorkScheduleSiteList",
    component: WorkScheduleSiteList,
  },
  {
    path: "/absence/types",
    name: "AbsenceTypeList",
    component: AbsenceTypeList,
    meta: {
      authorities: [
        PRIVILEGES.ABSENCE.TYPE.CREATE,
        PRIVILEGES.ABSENCE.TYPE.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/census/schedules",
    name: "WorkScheduleList",
    component: WorkScheduleList,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.WORKSCHEDULE.LIST,
        PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
  },
  {
    path: "/census/admin/work-schedule/:userId",
    name: "WorkScheduleFormAdmin",
    component: WorkScheduleForm,
    meta: {
      authorities: [
        PRIVILEGES.CENSUS.WORKSCHEDULE.EDIT,
        PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN,
      ],
      sidebarItemKey: "settings",
    },
    props: true,
  },

  {
    path: "/forecast/segment",
    name: "ForecastSegment",
    component: ForecastSegment,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.SEGMENT.LIST,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/forecast/chance-category",
    name: "ForecastChanceCategory",
    component: ForecastChanceCategory,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.CHANCE_CATEGORY.LIST,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/forecast/scenario",
    name: "ForecastScenario",
    component: ForecastScenario,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.SCENARIO.LIST,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/forecast/plan",
    name: "ForecastPlan",
    component: ForecastPlan,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_OWN,
        PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_ANY,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/forecast/fact",
    name: "ForecastFact",
    component: ForecastFact,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_OWN,
        PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_ANY,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  {
    path: "/forecast/dashboard",
    name: "ForecastDashboard",
    component: ForecastDashboard,
    meta: {
      authorities: [
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.DASHBOARD,
        PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN,
      ],
    },
  },
  // Dashboardok
  {
    path: "/dashboard/financial",
    name: "FinancialDashboard",
    component: FinancialDashboard,
    // TODO authorities
    meta: {
      breadcrumb: [
        { label: "sidebar.dashboard|Dashboard" },
        { label: "dashboard.financial.title|Pénzügyi vezérlőpult" },
      ],
    },
  },
  // Többiek
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    props: true,
    meta: {
      breadcrumb: [
        { label: "sidebar.profile|Profil" },
        { label: "sidebar.profile.own|Saját profil" },
      ],
    },
  },
  {
    path: "/user/:id",
    name: "UserProfile",
    component: Profile,
    props: true,
    /* meta: {
      authorities: [PRIVILEGES.CENSUS.USER.GET, PRIVILEGES.CENSUS.USER.ADMIN],
    }, */
  },
  {
    path: "/login",
    name: "SignIn",
    component: SignIn,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/register",
    name: "UserRegistration",
    component: UserRegistration,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/root",
    name: "RootSignIn",
    component: RootSignIn,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/reset-password/:token?",
    name: "Reset Password",
    component: ResetPassword,
    meta: {
      protected: false,
      loginLayout: true,
    },
  },
  {
    path: "/404",
    name: "NotFound",
    component: Other,
    meta: {
      protected: false,
    },
  },
  {
    path: "/onboarding/:onboardingToken",
    name: "Onboarding",
    component: OnboardingPage,
    meta: {
      protected: false,
      hideSidebar: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Other",
    component: Other,
    meta: {
      protected: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  console.debug("Routing to " + to.name);
  let isLoggedIn = store.getters["session/isReady"];
  if (to.meta && to.meta.protected === false) {
    if (isLoggedIn) {
      if (to.path === "/reset-password" || to.name === "Onboarding") {
        next();
      } else {
        next({ path: "/" });
      }
    } else {
      next();
    }
  } else {
    if (isLoggedIn && !to.meta?.authorities) {
      next();
    } else if (
      isLoggedIn &&
      to.meta?.authorities &&
      store.getters["session/hasAnyAuthority"](...to.meta.authorities)
    ) {
      next();
    } else {
      next({ path: "/login" });
    }
  }
});

export default router;
